import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/ServiceDetail";
import { serviceFaqs } from "@/data/serviceFaqs";
import { serviceGraph, abs } from "@/lib/serviceSchema";
import img from "@/assets/conference-av.jpg";

const bullets = [
  "Native video conferencing room certification on every major platform",
  "PTZ cameras, ceiling mic arrays, and beamforming audio",
  "LED video walls and 4K interactive displays",
  "Wireless presentation and screen sharing systems",
  "Digital signage and lobby displays",
  "Service-level agreements and on-site response",
];

export const Route = createFileRoute("/services/conference")({
  head: () => ({
    meta: [
      { title: "Conference Room & Office AV Install | Apex AV Denver" },
      { name: "description", content: "Video conferencing rooms, video walls, and presentation systems for Denver businesses. Commercial AV design and install for boardrooms and offices." },
      { name: "robots", content: "index, follow" },
      { name: "keywords", content: "conference room AV Denver, office AV installation Denver, video conferencing installation Denver, boardroom AV Denver, Zoom room installation Denver, Teams room installation Denver, commercial AV Denver, video wall installation Denver, presentation system Denver, digital signage Denver, microphone system Denver" },
      { property: "og:title", content: "Conference & Office AV — Apex AV Denver" },
      { property: "og:description", content: "Video conferencing, presentation systems, and video walls for Denver offices." },
      { property: "og:image", content: abs(img) },
      { name: "twitter:image", content: abs(img) },
      { property: "og:url", content: "https://apexav.com/services/conference" },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "Conference & Office AV — Apex AV Denver" },
      { name: "twitter:description", content: "Video conferencing, presentation systems, and video walls for Denver offices." },
    ],
    links: [{ rel: "canonical", href: "https://apexav.com/services/conference" }, { rel: "preload", as: "image", href: img, fetchPriority: "high" } as never],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceGraph({
            slug: "conference",
            name: "Conference & Office AV",
            description: "Video conferencing, video walls, and presentation systems for Denver businesses.",
            pageTitle: "Conference Room & Office AV Install | Apex AV Denver",
            pageDescription: "Video conferencing rooms, video walls, and presentation systems for Denver businesses. Commercial AV design and install for boardrooms and offices.",
            image: img,
            faqs: serviceFaqs["conference"],
            serviceType: "Conference & Office AV",
            breadcrumbName: "Conference & Office AV Denver",
            offerCatalog: bullets,
          })
        ),
      },
    ],
  }),
  component: () => (
    <ServiceDetail
      faqs={serviceFaqs["conference"]}
      topics={["av-installation", "networking", "smart-home", "whole-home-audio", "commercial"]}
      eyebrow="Commercial AV"
      title="Meetings that just work."
      intro={<>Native <strong>conference room AV in Denver</strong>, video conferencing rooms, <strong>video wall installation</strong>, presentation systems, and digital signage for boardrooms, offices, and all-hands spaces.</>}
      image={img}
      imageAlt="Conference room AV and video conferencing installation in a Denver Tech Center office"
      brands={["sony", "samsung", "lg", "sanus", "ubiquiti"]}
      bullets={bullets}
      features={[
        { title: "One-tap join", desc: "Walk in, tap the table, meeting starts. Same on every floor, every room." },
        { title: "Hear everyone", desc: "Ceiling mic arrays pick up the whole table — no passing handhelds." },
        { title: "Backed by SLA", desc: "Proactive monitoring and guaranteed response so your meetings run." },
      ]}
    />
  ),
});
